// extracted by mini-css-extract-plugin
export default {"numberOnImage":"styles__numberOnImage___KVc2Z","imageWrapper":"styles__imageWrapper___QAK4i","formGroup":"styles__formGroup___ROTug"};